import React, { useRef } from 'react';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { ReactComponent as ThreeDot } from '@zonofi/svg-icons/three-dot.svg';
import { TouchableOpacity, View, Text } from '../../../common';
import './options-tooltip.scss';

export interface OptionsTooltipItem {
  id?: string;
  icon: JSX.Element | string;
  text: string;
  onPress: () => void;
}

interface OptionsTooltipProps {
  actions: OptionsTooltipItem[];
}

export const OptionsTooltip: React.FC<OptionsTooltipProps> = ({ actions }) => {
  const popupRef = useRef<PopupActions>(null);

  if (actions.length === 0) return null;

  const handleActionPress = (onPress: () => void) => {
    onPress();
    popupRef.current?.close();
  };

  return (
    <Popup
      ref={popupRef}
      trigger={<ThreeDot color="#ffffff" />}
      position="bottom right"
      closeOnDocumentClick
      nested
      arrow={false}
    >
      <View className="tool-tip-view">
        {actions.map(({ id, icon, text, onPress }, index) => (
          <TouchableOpacity
            key={id ?? index}
            className="tool-tip-view--content"
            onPress={() => handleActionPress(onPress)}
          >
            {typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
            <Text className="tool-tip-view--text font-semibold">{text}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </Popup>
  );
};
